import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, ShieldCheck, Building2 } from "lucide-react";
import AcceptedPaymentsRow from "./AcceptedPaymentsRow";

const COMPANY_NAME = "Sterling Bio Ltd";
const COMPANY_NUMBER = "17209385";
const TRADING_ADDRESS = "128 City Road, London, EC1V 2NX, United Kingdom";
const PHONE = "+447916615097";
const PHONE_DISPLAY = "+44 7916 615097";
const EMAIL = "Info@sterlingbio.co.uk";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#1B3A5C] text-white mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="text-2xl font-semibold tracking-tight" style={{ fontFamily: "Outfit" }}>
            STERLING <span className="text-[#39B3C6]">BIO</span>
          </div>
          <div className="sb-mono-label !text-[#39B3C6] mt-1">Advanced bio solutions</div>
          <p className="mt-6 text-sm leading-relaxed text-white/75 max-w-md">
            UK supplier of laboratory-grade research peptides and bacteriostatic water. All
            products are supplied for in-vitro research only and are strictly not for human or
            veterinary consumption.
          </p>

          <div
            data-testid="footer-business-details"
            className="mt-6 flex flex-col gap-2 text-xs font-mono uppercase tracking-wider text-white/70"
          >
            <div className="flex items-start gap-2">
              <Building2 className="w-3.5 h-3.5 text-[#39B3C6] mt-0.5 shrink-0" />
              <span data-testid="footer-company-no">
                {COMPANY_NAME} · Company No. {COMPANY_NUMBER} (England &amp; Wales)
              </span>
            </div>
            <div className="flex items-start gap-2">
              <MapPin className="w-3.5 h-3.5 text-[#39B3C6] mt-0.5 shrink-0" />
              <span data-testid="footer-address">{TRADING_ADDRESS}</span>
            </div>
            <div className="flex items-center gap-2">
              <Phone className="w-3.5 h-3.5 text-[#39B3C6]" />
              <a
                href={`tel:${PHONE}`}
                data-testid="footer-phone"
                className="hover:text-[#39B3C6] transition-colors"
              >
                {PHONE_DISPLAY}
              </a>
            </div>
            <div className="flex items-center gap-2">
              <Mail className="w-3.5 h-3.5 text-[#39B3C6]" />
              <a
                href={`mailto:${EMAIL}`}
                className="hover:text-[#39B3C6] transition-colors normal-case tracking-normal"
              >
                {EMAIL}
              </a>
            </div>
            <div className="flex items-center gap-2">
              <ShieldCheck className="w-3.5 h-3.5 text-[#39B3C6]" /> SSL-secured checkout
            </div>
          </div>
        </div>

        <div>
          <div className="sb-mono-label !text-[#39B3C6]">Catalogue</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li><Link className="hover:text-[#39B3C6]" to="/products" data-testid="footer-products">All products</Link></li>
            <li><Link className="hover:text-[#39B3C6]" to="/cart" data-testid="footer-cart">Cart</Link></li>
            <li><Link className="hover:text-[#39B3C6]" to="/admin/orders" data-testid="footer-admin">Admin orders</Link></li>
          </ul>
        </div>

        <div>
          <div className="sb-mono-label !text-[#39B3C6]">Legal</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li><Link className="hover:text-[#39B3C6]" to="/terms" data-testid="footer-terms">Terms & Conditions</Link></li>
            <li><Link className="hover:text-[#39B3C6]" to="/refund-policy" data-testid="footer-refund">Refund &amp; Cancellation</Link></li>
            <li><Link className="hover:text-[#39B3C6]" to="/shipping" data-testid="footer-shipping">Shipping &amp; Delivery</Link></li>
            <li><Link className="hover:text-[#39B3C6]" to="/complaints" data-testid="footer-complaints">Complaints</Link></li>
            <li><Link className="hover:text-[#39B3C6]" to="/privacy-policy" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link className="hover:text-[#39B3C6]" to="/compliance" data-testid="footer-compliance">Compliance Disclaimer</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs">
          <div className="font-mono uppercase tracking-wider text-white/60">
            We accept
          </div>
          {/* Worldpay Clause 12.5(k) — global footer card-scheme display */}
          <div className="[&_.sb-mono-label]:!text-white/60 bg-white/5 rounded px-3 py-1.5">
            <AcceptedPaymentsRow compact />
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs font-mono uppercase tracking-wider text-white/60">
          <div>© {year} {COMPANY_NAME}. All rights reserved.</div>
          <div className="text-[#39B3C6]">For laboratory research only · Not for human use</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
